module.exports = __webpack_public_path__ + "img/pregnant.2008635b.png";